export * from '@platform/components/fullscreen/public-api';
